import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { errorToast, successToast } from "../../Toasts/Toasts";
import BankDetailsModal from "./BankDetailsModal";
import { updateSupplier } from "../../../services/supplierService";
import { countries } from "../../../utils/constants";

const ConfigurationSupplierModal = ({ showConfiguration, setShowConfiguration, supplierData: initialSupplierData = {} , type="", setShowBankDetails, masterData, onSaveSuccess, flag, setFlag }) => {
  const handleClose = () => setShowConfiguration(false);

  // Map supplier data to form field names
  const mappedSupplierData = initialSupplierData ? {
    id: initialSupplierData.id,
    name: initialSupplierData.name,
    country_id: initialSupplierData.country_id,
    currency: initialSupplierData.currency || 'AFN',
    thresholdAmount: initialSupplierData.threshold_local || initialSupplierData.thresholdLocalAmount,
    validity: initialSupplierData.validity,
    criticalBalance: initialSupplierData.critical_balance,
  } : {};

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: mappedSupplierData,
  });

  const onSubmit = async (data, event) => {
    const button = event.nativeEvent.submitter;
    button.disabled = true;

    let supplierInfo = {
      name: data.name,
      country_id: data.country_id,
      currency: data.currency,
      threshold_local: data.thresholdAmount,
      validity: data.validity,
      critical_balance: data.criticalBalance
    };
    try {
      const response = await updateSupplier(supplierInfo, data.id);
      button.disabled = false;
      // if (response?.success) {
        successToast(response?.message || "Supplier updated successfully");
      // }
      if (typeof setFlag === 'function') setFlag(!flag);
      if (typeof onSaveSuccess === 'function') onSaveSuccess();
      // Open bank details modal if type is 'Configuration', otherwise just close
      if (type === 'Configuration' && typeof setShowBankDetails === 'function') {
        setShowConfiguration(false);
        setShowBankDetails(true);
      } else {
        setShowConfiguration(false);
      }
    } catch (error) {
      errorToast(error?.response?.data?.message || "Failed to update supplier");
      button.disabled = false;
    }
  };

  const countryOptions = masterData?.countries?.map((c) => ({
    label: c.name,
    value: c.id,
    code: c.countryCode,
  }));

  const currencyOptions = masterData?.countries?.map((c) => c.currency)
    .filter((currency, index, arr) => arr.indexOf(currency) === index)
    .map((currency) => ({
      label: currency,
      value: currency,
    }));

  return (
    <Modal show={showConfiguration} size="lg" centered onHide={handleClose}>
      <div className="modal-simple modal-edit-user">
        <div className="modal-content p-3 p-md-3">
          <Modal.Body className="p-2">
            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close" />
            <div className="text-left mb-0">
              <h3 className="mb-3">Supplier Configuration</h3>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="supplier-id" className="form-label">ID</label>
                  <input id="supplier-id" type="text" className="form-control mb-3" disabled {...register("id")} />
                </div>
                <div className="col-lg-4">
                  <label htmlFor="supplier-name" className="form-label">Name</label>
                  <input id="supplier-name" type="text" className="form-control mb-3" {...register("name", { required: "Supplier name is required" })} />
                  <small className="text-danger">{errors?.name?.message}</small>
                </div>
                <div className="col-lg-4">
                  <label htmlFor="supplier-country" className="form-label">Country</label>
                  <select id="supplier-country" className="form-select mb-3" disabled {...register("country_id", { required: "Country is required" })}>
                    <option value="">...</option>
                    {countries.map((c) => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </select>
                  <small className="text-danger">{errors.country_id?.message}</small>
                </div>
                <div className="col-lg-4">
                  <label htmlFor="supplier-currency" className="form-label">Currency</label>
                  <select id="supplier-currency" className="form-select mb-3" disabled {...register("currency", { required: "Currency is required" })}>
                    <option value="">...</option>
                    {currencyOptions.map((currency) => (
                      <option key={currency.value} value={currency.value}>
                        {currency.label}
                      </option>
                    ))}
                  </select>
                  <small className="text-danger">{errors?.currency?.message}</small>
                </div>
                <div className="col-lg-4">
                  <label htmlFor="supplier-threshold-balance" className="form-label">Threshold Balance</label>
                  <div className="row g-2">
                    <div className="col-4">
                      <input id="supplier-threshold-balance" type="text" value={initialSupplierData?.currency} className="form-control" readOnly />
                    </div>
                    <div className="col-8">
                      <input type="number" step="1" className="form-control" {...register("thresholdAmount", {
                        required: "Threshold amount is required",
                        validate: {
                          wholeNumber: value => Number.isInteger(Number(value)) || "Threshold must be a whole number"
                        }
                      })} />
                    </div>
                  </div>
                  <small className="text-danger">{errors?.thresholdAmount?.message}</small>
                </div>
                <div className="col-lg-4">
                  <label htmlFor="supplier-critical-balance" className="form-label">Critical Balance</label>
                  <div className="row g-2">
                    <div className="col-4">
                      <input id="supplier-critical-balance" type="text" value={initialSupplierData?.currency} className="form-control" readOnly />
                    </div>
                    <div className="col-8">
                      <input type="number" step="1" className="form-control" {...register("criticalBalance", {
                        required: "Critical balance is required",
                        validate: {
                          wholeNumber: value => Number.isInteger(Number(value)) || "Critical balance must be a whole number"
                        }
                      })} />
                    </div>
                  </div>
                  <small className="text-danger">{errors?.criticalBalance?.message}</small>
                </div>

                <div className="col-lg-4">
                  <label htmlFor="supplier-validity" className="form-label">Validity</label>
                  <input id="supplier-validity" type="date" className="form-control mb-3" {...register("validity", { required: "Validity date is required" })} />
                  <small className="text-danger">{errors?.validity?.message}</small>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-center mt-4">
                  <button type="reset" className="btn btn-label-secondary rounded-pill btn-reset waves-effect me-2" onClick={handleClose} aria-label="Clear">
                    Clear
                  </button>
                  <button type="submit" className="btn btn-primary rounded-pill me-sm-3 me-1 waves-effect waves-light" aria-label="Save">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </div>
        <BankDetailsModal showBankDetails={setShowBankDetails} setShowConfiguration={setShowConfiguration} type={type} />
      </div>
    </Modal>
  );
};

export default ConfigurationSupplierModal;
